<template>
    <div class="relative">
        <div :class="{'hide-text' : isHideContent}">
            <div ref="text-zone" class="text-detail-content" v-html="text"></div>
        </div>
        <div v-show="isHideContent" class="bg-btn-show-text absolute bottom-0 left-0 w-full">
            <div class="flex justify-center items-center mt-9" @click="showFullText()">
                <div class="text-12 text-a-red-d62300">{{lbl.detail.more_detail}}</div>
                <img class="w-6" src="../../../../assets/arrow/arrow-down.svg">
            </div>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    mixins: [LocaleMixin],
    props: {
        text: { type: String, required: true },
    },
    data: function () {
        return {
            contentHeight: 0,

            isHideContent: true,
        };
    },
    mounted: function () {
        this.setHideText();
    },
    methods: {
        setHideText: function () {
            this.$nextTick(() => {
                let height = this.$refs['text-zone'].clientHeight;
                console.log(height);
                this.contentHeight = height;

                this.isHideContent = (height > 51);
                // this.isHideContent = true;
            });
        },
        showFullText: function () {
            this.isHideContent = false;
        },
    },
}
</script>
<style lang="scss" scoped>
    .hide-text {
        height: 100px;
        overflow: hidden;
    }
    .bg-btn-show-text {
        height: 60px;
        background: rgb(245,235,220);
        background: linear-gradient(180deg, rgba(245,235,220,0) 0%, rgba(245,235,220,0.85) 50%, rgba(245,235,220,1) 100%);
    }
</style>
<style lang="scss">
    .text-detail-content {
        ol {
            padding-left: 14px;
        }
        li[data-list="bullet"] {
            list-style-type: disc;
        }
        li[data-list="ordered"] {
            list-style-type: decimal;
        }

        h1 { 
            font-size: 24px;;
        }

        h2 { 
            font-size: 20px;
        }

        h3 { 
            font-size: 18px;
        }

        h4 { 
            font-size: 16px;
        }

        h5 { 
            font-size: 14px;
        }

        h6 { 
            font-size: 12px;
        }
    }
</style>
